// import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/pt-br'
import 'element-ui/lib/theme-chalk/index.css'
//import './assets/theme/theme-green/index.css'
import VueRouter from 'vue-router'
// import store from "./vuex/store";
import Vuex from 'vuex'
import routes from './routes'
// import Mock from './mock'
// Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'

Vue.use(ElementUI, { locale })
Vue.use(VueRouter)
Vue.use(Vuex)
// Vue.component('tabela', require('./views/consulta-nfe/Table.vue') )

const router = new VueRouter({
  routes
})

// Sincroniza logout entre abas: quando o 'user' é removido em uma aba, redireciona as demais
window.addEventListener('storage', event => {
  if (event.key === 'user' && !event.newValue) {
    router.push('/login')
  }
})

router.beforeEach((to, from, next) => {
  const user = JSON.parse(localStorage.getItem('user'))
  if (user && to.path === '/login') {
    next({ path: '/' })
  } else if (!user && to.path !== '/login') {
    next({ path: '/login' })
  } else {
    next()
  }
})

new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  // store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js